const dayjs = require('dayjs')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("Europe/London")
module.exports = dayjs
